import React__default from 'react';
import { StockIndicator } from '@grandvisionhq/inventory';
import { useIntl } from '@grandvisionhq/state';
import { VariantPickerVariant } from './components/VariantPickerVariant.js';

const VariantPicker = ({ variantItems , activeVariantSku , activeVariantLabel: activeVariantLabelProp , stockCount , isAllowBackOrder , enableStockIndicator , channelAvailability , onPick  })=>{
    var ref;
    const { getFormattedLabel , getLabel  } = useIntl();
    const activeVariantLabel = activeVariantLabelProp !== null && activeVariantLabelProp !== void 0 ? activeVariantLabelProp : (ref = variantItems.find((v)=>v.sku === activeVariantSku
    )) === null || ref === void 0 ? void 0 : ref.description;
    const labels = {
        title: getFormattedLabel('products.numberOfVariants', {
            labelData: {
                number: variantItems.length
            }
        }),
        screenreaderDefault: getLabel('products.variant.description.screenreader.fallback')
    };
    const stockIndicator = enableStockIndicator ? /*#__PURE__*/ React__default.createElement(StockIndicator, {
        stockCount: stockCount,
        allowBackOrder: isAllowBackOrder,
        channelAvailability: channelAvailability
    }) : null;
    if (!variantItems.length) {
        return null;
    }
    if (variantItems.length === 1) {
        return /*#__PURE__*/ React__default.createElement("div", {
            className: "variant-picker"
        }, /*#__PURE__*/ React__default.createElement("div", {
            className: "variant-picker__header"
        }, activeVariantLabel && /*#__PURE__*/ React__default.createElement("div", {
            className: "variant-picker__info"
        }, activeVariantLabel), stockIndicator));
    }
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "variant-picker"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "variant-picker__header"
    }, /*#__PURE__*/ React__default.createElement("strong", {
        id: "variants-label"
    }, labels.title), stockIndicator), /*#__PURE__*/ React__default.createElement("div", {
        className: "variant-picker__info"
    }, activeVariantLabel), /*#__PURE__*/ React__default.createElement("div", {
        className: "variant-picker__variants",
        role: "radiogroup"
    }, variantItems.map((variant)=>/*#__PURE__*/ React__default.createElement(VariantPickerVariant, {
            key: variant.sku,
            variant: variant,
            labels: labels,
            activeVariantSku: activeVariantSku,
            onPick: onPick
        })
    )));
};

export { VariantPicker };
//# sourceMappingURL=VariantPicker.js.map
